export default "__VITE_ASSET__7HmcUzfo__"